module.exports = __webpack_public_path__ + "img/header_logo.b8b25241.svg";